(function () {
  if (window.__hueAddToCartHandlerAttached) {
    return;
  }
  window.__hueAddToCartHandlerAttached = true;

  document.addEventListener('hue-add-to-cart', function (event) {
    const { variantId } = event.detail || {};

    if (!variantId) {
      console.warn('[hue-add-to-cart] No variantId in event detail', event.detail);
      return;
    }

    const formData = new FormData();
    formData.set('quantity', '1');
    formData.set('id', String(variantId));

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          console.error(
            '[hue-add-to-cart] /cart/add.js failed',
            response.status,
            response.statusText
          );
          return;
        }

        // Open cart drawer if available
        const cart = document.querySelector('cart-drawer');
        if (cart && typeof cart.show === 'function') {
          cart.show();
        }
      })
      .catch(function (error) {
        console.error('[hue-add-to-cart] Network error', error);
      });
  });
})();